import { WordBuilder as WordBuilderIcon } from "assets/icons";
import { InformationSetting, RememberSettings, ToggleSetting } from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";

import { PhonemesSetting } from "./PhonemesSetting";
import { SoundSlot, WordBuilder, WordBuilderState } from "./WordBuilder";

const DEFAULT_VALUE: SoundSlot[] = [{ value: "" }, { value: "" }, { value: "" }];

export const WordBuilderkWidget: WidgetType<WordBuilderState> = {
  name: "Word Builder",
  component: WordBuilder,
  icon: WordBuilderIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 380,
    minHeight: 320,
    minAspectRatio: 1.19,
    maxAspectRatio: 1.19,
  },
  defaultState: {
    soundSlots: DEFAULT_VALUE,
    heartSlots: [],
  },
  defaultSize: {
    aspectRatio: 1,
    widthPercentage: 40,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Construct words and read them aloud by dragging and arranging letters and phonemes.",
      },
    },
    phonemesDisabled: {
      editor: PhonemesSetting,
      info: {},
      defaultValue: {
        single: { disabled: false, disabledSounds: [] },
        consonant: { disabled: true, disabledSounds: [] },
        commonlongvowels: { disabled: true, disabledSounds: [] },
        otherlongvowels: { disabled: true, disabledSounds: [] },
        otherconsonant: { disabled: true, disabledSounds: [] },
      },
    },
    heartParts: {
      editor: ToggleSetting,
      info: {
        label: "Heart Words",
      },
      defaultValue: true,
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.wordBuilder,
        widgetDisplayName: "Word Builder",
      },
    },
  },
  quickActions: {},
};
